(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentApprovalByHashIdController', DocumentApprovalByHashIdController);

    DocumentApprovalByHashIdController.$inject = ['$uibModalInstance', '$translate', 'entity', 'Document', 'CurrencyUtils'];

    function DocumentApprovalByHashIdController($uibModalInstance, $translate, entity, Document, CurrencyUtils) {
        var vm = this;

        vm.document = entity;
        vm.approving = false;
        vm.statement = null;
        vm.recipientEmail = null;
        vm.clear = clear;
        vm.confirmApproval = confirmApproval;
        vm.getCurrency = CurrencyUtils.getCurrency;

        // The wording is fetched rather than composed here. The same server-side renderer produces
        // the sentence shown and the sentence stored on the evidence row, so the two cannot drift.
        // Until it arrives the Approve button stays disabled: nobody accepts text they were not
        // shown.
        Document.approvalStatement({ hash: vm.document.hashedId }).$promise.then(function (result) {
            vm.statement = result.statement;
            vm.recipientEmail = result.recipientEmail;
            vm.locale = result.locale;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmApproval(hashedId) {
            // Guards the double-submit this dialog used to invite: with no error handling, a
            // failed approval left the dialog exactly as it was, so recipients pressed Approve
            // again. Production saw the same person do it up to ten times.
            if (vm.approving) {
                return;
            }
            vm.approving = true;

            Document.approveByHashId(
                { hash: hashedId, locale: vm.locale || $translate.use() },
                {},
                function () {
                    vm.approving = false;
                    $uibModalInstance.close(true);
                },
                function () {
                    vm.approving = false;
                    // No 401 branch any more - approving no longer requires a session, so there is
                    // no expired-session case to recover from. Anything that fails here has already
                    // surfaced through the global error handler; close rather than leave the
                    // recipient with a dead dialog.
                    $uibModalInstance.dismiss('failed');
                });
        }
    }
})();
